import firebase from 'firebase';
import _ from 'lodash';
import appEvts from '../_services/app-events.service.js';

import View from '../_components/view/view.js';
import sectionsBarTpl from './sections-bar.tpl.html';
import './sections-bar.styles.less';


class SectionsBarView extends View {

	constructor (data, options) {
		
		super(sectionsBarTpl, data, options);
		
		this.render(data);
	}

	uiElements() {
		return _.extend(super.uiElements(), {
			homeSectionBtn: '.btn-home-section',
			normativeSectionBtn: '.btn-normative-section',
			adminSectionBtn: '.btn-admin-section',
			newsSectionBtn: '.btn-news-section',
			historicSectionBtn: '.btn-history-section'
		});
	}

	render(data) {
		super.render(data);
	}

	initializeEvents() {
		//UI Events
		this.ui.homeSectionBtn.click(() => this.changeSection('home'));
		this.ui.normativeSectionBtn.click(() => this.changeSection('normative'));
		this.ui.adminSectionBtn.click(() => this.changeSection('admin'));
		this.ui.newsSectionBtn.click(() => this.changeSection('news'));
		this.ui.historicSectionBtn.click(() => this.changeSection('historic'));
		
		//Database Events
		firebase.auth().onAuthStateChanged( user => {
			firebase.database().ref('/admins').once('value')
			.then(__admins => {
				if (__admins.val()[user.uid]) {
					this.ui.adminSectionBtn.removeClass('hidden');
				} else {
					this.ui.adminSectionBtn.addClass('hidden');
				}
			});

		});

		window.onpopstate = (evt) => {
			appEvts.trigger('goto:section:' + event.state);
		};
	}

	changeSection(sectionName) {
		window.history.pushState(sectionName, sectionName, '/?section=' + sectionName);
		
		appEvts.trigger('goto:section:' + sectionName);
	}

	remove() {
		super.remove();
		this.ui.adminSectionBtn.off();
	}

}

export default SectionsBarView;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/sections-bar/sections-bar.view.js